'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEnvelope$002dDetail$002dPage from "./presto.-Envelope-Detail-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_EnvelopeDetailPage$() {
}
export { $c_Lpresto_EnvelopeDetailPage$ as $c_Lpresto_EnvelopeDetailPage$ };
$p = $c_Lpresto_EnvelopeDetailPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_EnvelopeDetailPage$;
/** @constructor */
function $h_Lpresto_EnvelopeDetailPage$() {
}
export { $h_Lpresto_EnvelopeDetailPage$ as $h_Lpresto_EnvelopeDetailPage$ };
$h_Lpresto_EnvelopeDetailPage$.prototype = $p;
$p.l = (function() {
  return "EnvelopeDetailPage";
});
$p.cG7 = (function(x$0) {
  return new $j_presto$002e$002dEnvelope$002dDetail$002dPage.$c_Lpresto_EnvelopeDetailPage($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)));
});
var $d_Lpresto_EnvelopeDetailPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_EnvelopeDetailPage$, "presto.EnvelopeDetailPage$", ({
  Ir: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_EnvelopeDetailPage$ as $d_Lpresto_EnvelopeDetailPage$ };
var $n_Lpresto_EnvelopeDetailPage$;
function $m_Lpresto_EnvelopeDetailPage$() {
  if ((!$n_Lpresto_EnvelopeDetailPage$)) {
    $n_Lpresto_EnvelopeDetailPage$ = new $c_Lpresto_EnvelopeDetailPage$();
  }
  return $n_Lpresto_EnvelopeDetailPage$;
}
export { $m_Lpresto_EnvelopeDetailPage$ as $m_Lpresto_EnvelopeDetailPage$ };
//# sourceMappingURL=presto.-Envelope-Detail-Page$.js.map
